import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { switchTab } from '../actions/extension-emote';
export default handleActions({
    [`${switchTab}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            selectorSection: action.payload.tab
        })
}, {
    selectorSection: 'emoji'
});

//# sourceMappingURL=extension-emote.js.map